import 'view/css/srv-log-view.css';

import moment from 'moment';
import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faFileExcel,
} from '@fortawesome/free-solid-svg-icons';

import API from 'service/api';
import Util, { Data } from 'service/util';
import Protected from 'component/Protected';
import Loading from 'component/Loading';
import LocationSelect from 'component/dropdown/LocationSelect';

import DatePicker from 'react-datepicker';

const today = moment().startOf('day').toDate();

const ServiceLogView = (props) =>
{
  const [ls_staff, setStaffList] = useState([]);

  const [from_dtm, setFromDate]   = useState(today);
  const [to_dtm, setToDate]   = useState(today);
  const [company, setCompany] = useState('');
  const [district, setDistrict] = useState('');
  const [location, setLocation] = useState('');

  const [staff_name, setFilterName] = useState('');
  const [exporting, setExporting] = useState(false);

  const [data, setData]     = useState(null);
  const [items, setItems]   = useState(null);

  const onSetLocation = (dist, loc) => {
    setDistrict(dist);
    setLocation(loc);
  }

  const updateFilter = (apiData) =>
  {
    if (apiData) setData(apiData);

    // execute filter
    let ls = apiData || data;
    if (!ls) return;
    setStaffList(Array.from(new Set(ls.map(x => x.create_by))));

    if (company) ls = ls.filter(x => x.company == company);
    if (district) {
      ls = ls.filter(x => x.srv_dis == district);
      if (location) ls = ls.filter(x => x.srv_loc == location);
    }

    let _name = String(staff_name).trim().toUpperCase();
    if (_name) ls = ls.filter(x => -1<String(x.create_by).toUpperCase().indexOf(_name));

    setItems(ls);
  }

  useEffect(() => {
    // display state
    setItems(null);
    // start load data
    API.getVhServicesByDate({from_dtm, to_dtm}).then(data => {
      updateFilter(data);
    });
  }, [from_dtm, to_dtm])

  useEffect(() => {
    updateFilter();
  }, [company, district, location, staff_name]);


  //----------
  const exportXls = () => {
    if (exporting) return false;
    setExporting(true);
    let fdate = Util.ShortDate(from_dtm);
    let tdate = Util.ShortDate(to_dtm);
    let dto = {
       from_dtm
      ,to_dtm
      ,company
      ,srv_dis: district
      ,srv_loc: location
      ,staff_name
    };
    API.exportServiceRecord(dto).then(resp => {
      const ix_date = moment().format('YYYYMMDD');
      Util.download(resp, `${fdate}至${tdate}月費記錄_${ix_date}.xlsx`);
      setExporting(false);
    });
  }


  return (
    <>
      <h1>紀錄 - 月費服務紀錄</h1>
      <div className="srv-log-view">
        <div className="action-panel">
          <div className="row search-bar">
            <label className="field-row">
              <strong>建立日期由</strong>
              <DatePicker selected={from_dtm} onChange={setFromDate}
                dateFormat="yyyy-MM-dd" />
            </label>
            <label className="field-row">
              <strong>至</strong>
              <DatePicker selected={to_dtm} onChange={setToDate}
                dateFormat="yyyy-MM-dd" />
            </label>
            <label className="field-row">
              <strong>公司</strong>
              <select value={company} onChange={e=>setCompany(e.target.value)}>
                <option value="">全部</option>
                { Data.company.map(com =>
                  <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
                )}
              </select>
            </label>
            <LocationSelect labelClass="field-row" all={true}
              district={district} location={location}
              onUpdate={onSetLocation}
              />
            <label className="field-row">
              <strong>負責同事</strong>
              <select value={staff_name} onChange={e=>setFilterName(e.target.value)}>
                <option value="">全部</option>
                { ls_staff.map(s => <option key={s} value={s}>{ s }</option>) }
              </select>
            </label>
          </div>
          <div>
            { items?.length >0 &&
              <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_DAY','VIEWER_NIGHT']}>
                <button className="btn dark-green btn-export" disabled={exporting}
                  onClick={exportXls}>
                  <FontAwesomeIcon icon={faFileExcel} />
                  <span> 匯出</span>
                </button>
              </Protected>
            }
          </div>
        </div>
        <div className="srv-log-view-body">
        { !items ? <Loading/>
          :items.length <= 0 ? <p className="message yellow">沒有記錄</p>
          :<table className="data-table full-width">
            <colgroup>
              <col width="60px"  id="col-srv-log-company" />
              <col width="100px" id="col-srv-log-license" />
              <col width="60px"  id="col-srv-log-plan" />
              <col width="60px"  id="col-srv-log-vh-type" />
              <col width="100px" id="col-srv-log-reg-date" />
              <col width="100px" id="col-srv-log-start-date" />
              <col width="100px" id="col-srv-log-end-date" />
              <col width="30px"  id="col-srv-log-loc" />
              <col width="80px"  id="col-srv-log-fee" />
              <col width="80px"  id="col-srv-log-extra-fee" />
              <col width="120px" id="col-srv-log-rotation" />
              <col width="50px"  id="col-srv-log-weekday1" />
              <col width="50px"  id="col-srv-log-weekday2" />
              <col width="50px"  id="col-srv-log-weekday3" />
              <col width="120px" id="col-srv-log-waxing" />
              <col width="160px" id="col-srv-log-worker" />
              <col width="160px" id="col-srv-log-create-date" />
              <col width="160px" id="col-srv-log-by" />
            </colgroup>
            <thead>
              <tr>
                <th className="col-srv-log-company">公司</th>
                <th className="col-srv-log-license">車牌</th>
                <th className="col-srv-log-plan">計劃</th>
                <th className="col-srv-log-vh-type">車種</th>
                <th className="col-srv-log-reg-date">開戶日期</th>
                <th className="col-srv-log-start-date">開始日期</th>
                <th className="col-srv-log-end-date">結束日期</th>
                <th className="col-srv-log-loc">地點</th>
                <th className="col-srv-log-fee">月費</th>
                <th className="col-srv-log-extra-fee">附加費</th>
                <th className="col-srv-log-rotation">附加項目</th>
                <th className="col-srv-log-weekday1">D1</th>
                <th className="col-srv-log-weekday2">D2</th>
                <th className="col-srv-log-weekday3">D3</th>
                <th className="col-srv-log-waxing">打蠟</th>
                <th className="col-srv-log-worker">工人</th>
                <th className="col-srv-log-create-date">紀錄日期</th>
                <th className="col-srv-log-by">負責同事</th>
              </tr>
            </thead>
            <tbody>
              { items.map((x, i) =>
                <tr key={i}>
                  <td className="col-srv-log-company">{ Util.getCompanyName(x.company) }</td>
                  <td className="col-srv-log-license">
                    <a href={`/op/services/${x.cd_license}`}>{ x.cd_license }</a>
                  </td>
                  <td className="col-srv-log-plan">{ x.srv_plan }</td>
                  <td className="col-srv-log-vh-type">{ x.vh_type }</td>
                  <td className="col-srv-log-reg-date">{ Util.ShortDate(x.reg_dtm) }</td>
                  <td className="col-srv-log-start-date">{ Util.ShortDate(x.start_dtm) }</td>
                  <td className="col-srv-log-end-date">{ Util.ShortDate(x.end_dtm) }</td>
                  <td className="col-srv-log-loc">{ x.srv_dis }{ x.srv_loc }</td>
                  <td className="col-srv-log-fee">${ Util.nf(x.fee) }</td>
                  <td className="col-srv-log-extra-fee">${ Util.nf(x.extra_fee) }</td>
                  <td className="col-srv-log-rotation">{ x.rotation }</td>
                  <td className="col-srv-log-weekday1">{ x.weekday1 }</td>
                  <td className="col-srv-log-weekday2">{ x.weekday2 }</td>
                  <td className="col-srv-log-weekday3">{ x.weekday3 }</td>
                  <td className="col-srv-log-waxing">
                    { !!x.waxing && <FontAwesomeIcon icon={faCheck} /> }
                  </td>
                  <td className="col-srv-log-worker">{ x.worker_name } ({ x.worker })</td>
                  <td className="col-srv-log-create-date">{ Util.FullDate(x.create_dtm) }</td>
                  <td className="col-srv-log-by" title={`更新日期: ${Util.ShortDate(x.mod_dtm)}`}>{ x.create_by }</td>
                </tr>
              )}
            </tbody>
          </table>
        }
        </div>
      </div>
    </>
  );
}

export default ServiceLogView;
